import { combineReducers } from 'redux';
import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';

import actionTypes from './actionTypes';

/* State shape:
 {
 loadingState: {
     isLoading: bool
     success: bool
     errors: Array
 },
 seasonHighsState: {
     goalsFor: Array

 }
 }
 */

const loadingStateReducer = loadingStateReducerFactory

const goalsForLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_GOALS_FOR_DATA)(actionTypes.SEASON_HIGHS_GOALS_FOR_RESPONSE);
const shotsLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_SHOTS_DATA)(actionTypes.SEASON_HIGHS_SHOTS_RESPONSE);
const pimLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_PIM_DATA)(actionTypes.SEASON_HIGHS_PIM_RESPONSE);
const ppgLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_PPG_DATA)(actionTypes.SEASON_HIGHS_PPG_RESPONSE);

const playerGoalsLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_PLAYER_GOALS_DATA)(actionTypes.SEASON_HIGHS_PLAYER_GOALS_RESPONSE);
const playerAssistsLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_PLAYER_ASSISTS_DATA)(actionTypes.SEASON_HIGHS_PLAYER_ASSISTS_RESPONSE);
const playerPointsLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_PLAYER_POINTS_DATA)(actionTypes.SEASON_HIGHS_PLAYER_POINTS_RESPONSE);
const playerPPGLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_PLAYER_PPG_DATA)(actionTypes.SEASON_HIGHS_PLAYER_PPG_RESPONSE);
const playerShotsLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_PLAYER_SHOTS_DATA)(actionTypes.SEASON_HIGHS_PLAYER_SHOTS_RESPONSE);
const playerPIMLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_PLAYER_PIM_DATA)(actionTypes.SEASON_HIGHS_PLAYER_PIM_RESPONSE);
const playerTOILoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_PLAYER_TOI_DATA)(actionTypes.SEASON_HIGHS_PLAYER_TOI_RESPONSE);

const goalieShotsAgainstLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_GOALIE_SHOTS_AGAINST_DATA)(actionTypes.SEASON_HIGHS_GOALIE_SHOTS_AGAINST_RESPONSE);
const goalieSavesLoadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_SEASON_HIGHS_GOALIE_SAVES_DATA)(actionTypes.SEASON_HIGHS_GOALIE_SAVES_RESPONSE);



const goalsForReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_GOALS_FOR_RESPONSE:
            return action.payload.goalsForData || [];
        default: return state;
    }
};

const shotsReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_SHOTS_RESPONSE:
            return action.payload.shotsData || [];
        default: return state;
    }
};

const penaltyMinutesReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_PIM_RESPONSE:
            return action.payload.pimData || [];
        default: return state;
    }
};

const powerplayGoalsReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_PPG_RESPONSE:
            return action.payload.ppgData || [];
        default: return state;
    }
};


const playerGoalsReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_PLAYER_GOALS_RESPONSE:
            return action.payload.playerGoalsData || [];
        default: return state;
    }
};

const playerAssistsReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_PLAYER_ASSISTS_RESPONSE:
            return action.payload.playerAssistsData || [];
        default: return state;
    }
};

const playerPointsReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_PLAYER_POINTS_RESPONSE:
            return action.payload.playerPointsData || [];
        default: return state;
    }
};

const playerPowerplayGoalsReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_PLAYER_PPG_RESPONSE:
            return action.payload.playerPPGData || [];
        default: return state;
    }
};

const playerShotsReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_PLAYER_SHOTS_RESPONSE:
            return action.payload.playerShotsData || [];
        default: return state;
    }
};

const playerPIMReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_PLAYER_PIM_RESPONSE:
            return action.payload.playerPIMData || [];
        default: return state;
    }
};

const playerTOIReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_PLAYER_TOI_RESPONSE:
            return action.payload.playerTOIData || [];
        default: return state;
    }
};

const goalieShotsAgainstReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_GOALIE_SHOTS_AGAINST_RESPONSE:
            return action.payload.goalieShotsAgainstData || [];
        default: return state;
    }
};

const goalieSavesReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.SEASON_HIGHS_GOALIE_SAVES_RESPONSE:
            return action.payload.goalieSavesData || [];
        default: return state;
    }
};

const loadingStateReducers = combineReducers({
    goalsForLoadingState: goalsForLoadingStateReducer,
    shotsLoadingState: shotsLoadingStateReducer,
    pimLoadingState: pimLoadingStateReducer,
    ppgLoadingState: ppgLoadingStateReducer,

    playerGoalsLoadingState: playerGoalsLoadingStateReducer,
    playerAssistsLoadingState: playerAssistsLoadingStateReducer,
    playerPointsLoadingState: playerPointsLoadingStateReducer,
    playerPPGLoadingState: playerPPGLoadingStateReducer,
    playerShotsLoadingState: playerShotsLoadingStateReducer,
    playerPIMLoadingState: playerPIMLoadingStateReducer,
    playerTOILoadingState: playerTOILoadingStateReducer,
    goalieShotsAgainstLoadingState: goalieShotsAgainstLoadingStateReducer,
    goalieSavesLoadingState: goalieSavesLoadingStateReducer

});

const seasonHighsStateReducer =  combineReducers({
    goalsFor: goalsForReducer,
    shots: shotsReducer,
    pim: penaltyMinutesReducer,
    ppg: powerplayGoalsReducer,

    playerGoals: playerGoalsReducer,
    playerAssists: playerAssistsReducer,
    playerPoints: playerPointsReducer,
    playerPPG: playerPowerplayGoalsReducer,
    playerShots: playerShotsReducer,
    playerPIM: playerPIMReducer,
    playerTOI: playerTOIReducer,

    goalieShotsAgainst: goalieShotsAgainstReducer,
    goalieSaves: goalieSavesReducer
});

const reducer = combineReducers({
    loadingState: loadingStateReducers,
    seasonHighsState: seasonHighsStateReducer
});

export default reducer;
